export default __webpack_public_path__ + "static/Rubicon-scrubber-machine-icon-7ec94af8bf0af0a96d44dfec1b63a3b7.png";